import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

function loadLocaleMessages() {
    const locales = require.context(
        "./../lang/forms",
        true,
        /[A-Za-z0-9-_,\s]+\.json$/i
    );
    const messages = {};
    locales.keys().forEach(key => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i);
        if (matched && matched.length > 1) {
            const locale = matched[1];
            messages[locale] = locales(key);
        }
    });
    return messages;
}

function getLang() {
    const spanish_dialects = ["es", "ca", "eu", "gl"];
    const chinese_dialects = ["zh", "zh-Hans", "zh-Hant"];
    const lang = document.documentElement.lang;
    if (spanish_dialects.includes(lang)) {
        return "es";
    } else if (chinese_dialects.includes(lang)) {
        return "zh";
    } else {
        return "en";
    }
}

export const defaultLocale = getLang();

export default new VueI18n({
    locale: getLang(),
    fallbackLocale: "en",
    messages: loadLocaleMessages()
});
